<template>
  <div>
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 class="profile-section-title">
        <i class="ni ni-align-center"></i>لیست کسب و کارها
      </h4>
    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
          <section id="section-1" class="">
            <div
              style="text-align: center"
              class="col-md-12 loading"
              v-if="isLoading"
            >
              <loadingBar type="ripple" />
            </div>
            <div v-else>
              <div class="row" style="margin-bottom: 15px">
                <div class="col-md-11"></div>
                <div class="col-md-1 close-btn">
                  <router-link to="/profile/dashboard">
                    <div title="بازگشت به داشبورد" class="close"></div>
                  </router-link>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px">
                <div class="col-lg-9"></div>
                <div class="col-lg-3" v-if="businessList.length < 1">
                  <router-link
                    class="btn btn-primary"
                    to="/profile/business"
                    >افزودن کسب و کار
                  </router-link>
                </div>
              </div>

              <div class="row rtl">
                <div class="col-lg-10"></div>
                <div class="col-lg-3 add-btn"></div>
              </div>
              <userBusinessSort @sortBy="sort" style="margin-top: -30px" />

              <div
                class="strip_booking"
                v-for="business in businessList"
                :key="business.id"
              >
                <div class="row">
                  <div class="col-lg-3 col-md-3 text-view">
                    <strong>{{ business.name }} </strong>
                  </div>

                  <div
                    class="col-lg-3 col-md-3 text-view"
                    v-if="business.sourceType == 1"
                  >
                    آژانس
                  </div>

                  <div
                    class="col-lg-3 col-md-3 text-view"
                    v-if="business.sourceType == 2"
                  >
                    شرکت یا سازمان یا ...
                  </div>

                  <div class="col-lg-3 col-md-3 text-view date-vertical">
                    {{ business.createdDate | persianDate("jYYYY/jMM/jDD") }}
                  </div>
                  <div class="col text-view">
                    <div
                      class="booking_buttons"
                      v-if="business.sourceType == 1"
                    >
                      <router-link
                        class="btn btn-primary"
                        :to="{
                          name: 'business',
                          params: {
                            sourceId: business.id,
                            sourceProfileId: business.profileId,
                            sourceType: 1,
                          },
                        }"
                        >ویرایش</router-link
                      >

                      <a href class="btn btn-danger">حذف</a>
                    </div>

                    <div
                      class="booking_buttons"
                      v-if="business.sourceType == 2"
                    >
                      <router-link
                        class="btn btn-primary"
                        :to="{
                          name: 'business',
                          params: {
                            sourceId: business.id,
                            sourceProfileId: business.profileId,
                            sourceType: 2,
                          },
                        }"
                        >ویرایش</router-link
                      >

                      <a href class="btn btn-danger">حذف</a>
                    </div>
                  </div>
                  <!-- End row -->
                </div>
              </div>
            </div>
            <!-- End strip booking -->
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../views/profile/store/index";
import userBusinessSort from "./UserBusinessSort";
import loadingBar from "../../components/loading/pdkLoadingBar";

export default {
  name: "UserBusinessList",
  store: Store,
  components: {
    userBusinessSort,
    loadingBar,
  },
  data() {
    return {
      relatedProfileId: "",
      profileId: "",
      sortType: "",
      isLoading: false,
    };
  },
  mounted() {
    this.loadList();
  },
  created() {
    // BusEvent.$on("sortBy", (data) => {
    //   this.sort(data);
    // });
  },
  computed: {
    businessList() {
      return this.$store.getters.getAllBusiness;
    },
  },

  methods: {
    async loadList() {
      this.isLoading = true;
      await this.$store.dispatch("getUserId").then(() => {
        this.relatedProfileId = this.$store.getters.GetUserId;

        this.$store.dispatch("getBusinessList", {
          relatedProfileId: this.relatedProfileId,
          sort: "",
          ascending: false,
        });
        this.isLoading = false;
      });
    },

    sort(sort) {
      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }

      if (this.ascending) sort + "  ASC ";
      else sort += "   Desc ";

      this.$store.dispatch("getBusinessList", {
        relatedProfileId: this.relatedProfileId,
        sort: sort,
      });
    },
  },
};
</script>

<style scoped>
.strip_booking {
  border-bottom: 1px solid #ededed;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

ul.info_booking {
  padding: 15px 0 15px 25px;
  border-right: 0;
  border-left: 1px solid #ededed;
  text-align: left;
  font-size: 11px;
  color: #999;
  line-height: 12px;
}

a.btn_2,
.btn_2,
a.btn_3,
.btn_3 {
  border: none;
  font-family: inherit;
  font-size: 15px !important;
  color: #162949;
  background: rgb(230, 168, 27);
  background: linear-gradient(
    67deg,
    rgba(230, 168, 27, 1) 0%,
    rgba(255, 197, 64, 1) 100%
  );
  cursor: pointer;
  padding: 15px 8px;
  font-size: 11px;
  line-height: 9px;
  display: block;
  outline: none;
  transition: all 0.3s;
  border-radius: 36px;
  text-align: center;
}

.add-btn {
  text-align: center;
  left: 0 !important;
  margin: 0px 0px 30px 0px !important;
}

a.btn_3:hover,
.btn_3:hover {
  background: rgb(185, 133, 10);
  color: #fff;
}

a.btn_3,
.btn_3 {
  font-family: inherit;
  font-size: 15px !important;
  color: #162949;
  background: rgb(230, 168, 27);
  background: linear-gradient(
    67deg,
    rgba(230, 168, 27, 1) 0%,
    rgba(255, 197, 64, 1) 100%
  );
  cursor: pointer;
  padding: 15px 8px;
  font-size: 11px;
  line-height: 9px;
  display: block;
  outline: none;
  transition: all 0.3s;
  border-radius: 36px;
  text-align: center;
}

.text-view {
  text-align: center !important;
}

.date-vertical {
  border-left: 1px solid #ededed;
  text-align: center !important;
  margin-right: 11px;
}

.headr-list {
  font-size: 16px;
  color: #151414;
  margin-top: 5px;
  height: 34px;
}

.heafer-icon {
  float: left !important;
  text-align: left !important;
  font-size: 28px;
  color: #008489 !important;
  margin-top: 5px;
}

.booking_buttons {
  margin: 0px 30px 0px 30px;
}
</style>